<template>
  <div v-if="editor" class="mb-2" id="lm-editor-text-menu">
    <div class="shadow rounded p-1 border border-light editor-menu">
      <MenuButton
        title="Encabezado 1"
        icon="format-header-1"
        @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }"
      />
      <MenuButton
        title="Encabezado 2"
        icon="format-header-2"
        @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
      />
      <MenuButton
        title="Encabezado 3"
        icon="format-header-3"
        @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }"
      />
      <MenuButton
        title="Encabezado 4"
        icon="format-header-4"
        @click="editor.chain().focus().toggleHeading({ level: 4 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 4 }) }"
      />
      <MenuButton
        title="Izquierda"
        icon="format-align-left"
        @click="editor.chain().focus().setTextAlign('left').run()"
        :class="{ 'is-active': editor.isActive({ textAlign: 'left' }) }"
      />
      <MenuButton
        title="Centrado"
        icon="format-align-center"
        @click="editor.chain().focus().setTextAlign('center').run()"
        :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) }"
      />
      <MenuButton
        title="Derecha"
        icon="format-align-right"
        @click="editor.chain().focus().setTextAlign('right').run()"
        :class="{ 'is-active': editor.isActive({ textAlign: 'right' }) }"
      />
      <MenuButton
        title="Justificado"
        icon="format-align-justify"
        @click="editor.chain().focus().setTextAlign('justify').run()"
        :class="{ 'is-active': editor.isActive({ textAlign: 'justify' }) }"
      />
      <MenuButton
        title="Párrafo"
        icon="format-paragraph"
        @click="editor.chain().focus().setParagraph().run()"
        :class="{ 'is-active': editor.isActive('paragraph') }"
      />
      <MenuButton
        title="Negrita"
        icon="format-bold"
        @click="editor.chain().focus().toggleBold().run()"
        :class="{ 'is-active': editor.isActive('bold') }"
      />
      <MenuButton
        title="Itálica"
        icon="format-italic"
        @click="editor.chain().focus().toggleItalic().run()"
        :class="{ 'is-active': editor.isActive('italic') }"
      />
      <MenuButton
        title="Subrayado"
        icon="format-underline"
        @click="editor.chain().focus().toggleUnderline().run()"
        :class="{ 'is-active': editor.isActive('underline') }"
      />
      <MenuButton
        title="Código"
        icon="code-tags"
        @click="editor.chain().focus().setCode().run()"
        :class="{ 'is-active': editor.isActive('code') }"
      />
      <MenuButton
        title="Cita"
        icon="format-quote-close"
        @click="editor.chain().focus().toggleBlockquote().run()"
        :class="{ 'is-active': editor.isActive('blockquote') }"
      />
      <MenuButton
        title="Listado"
        icon="format-list-bulleted"
        @click="editor.chain().focus().toggleBulletList().run()"
        :class="{ 'is-active': editor.isActive('bulletList') }"
      />
      <MenuButton
        title="Listado Ordenado"
        icon="format-list-numbered"
        @click="editor.chain().focus().toggleOrderedList().run()"
        :class="{ 'is-active': editor.isActive('orderedList') }"
      />
      <MenuButton
        title="Línea Horizontal"
        icon="minus"
        @click="editor.chain().focus().setHorizontalRule().run()"
      />
      <MenuButton
        title="Deshacer"
        icon="undo-variant"
        @click="editor.chain().focus().undo().run()"
        :disabled="!editor.can().undo()"
      />
      <MenuButton
        title="Rehacer"
        icon="redo-variant"
        @click="editor.chain().focus().redo().run()"
        :disabled="!editor.can().redo()"
      />
      <MenuButton
        title="Identar menos"
        icon="format-indent-decrease"
        @click="editor.commands.outdent()"
      />
      <MenuButton
        title="Identar más"
        icon="format-indent-increase"
        @click="editor.commands.indent()"
      />
      <MenuButton
        title="Configuración de Tabla"
        icon="table-cog"
        @click="$emit('toggle-table-settings')"
      />
      <MenuButton
        v-if="hasVariables"
        title="Variables"
        icon="variable"
        @click="$emit('toggle-variables')"
      />
    </div>
  </div>
</template>

<script>
import MenuButton from './MenuButton'

export default {
  props: {
    editor: Object,
    hasVariables: Boolean
  },
  components: {
    MenuButton
  }
}
</script>

<style lang="sass">
#lm-editor-text-menu
  .is-active
    background-color: #dbdbdb
#lm-editor-text-menu
  .editor-menu
    display: grid
    grid-template-columns: repeat(auto-fill, minmax(35px, 1fr))
    grid-column-gap: 10px
</style>
